export const config = {
  REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL
    ? process.env.REACT_APP_BACKEND_URL.replace(/\/+$/, '')
    : undefined,
  REACT_APP_FRONTEND_BASE_URL: process.env.REACT_APP_FRONTEND_BASE_URL ? process.env.REACT_APP_FRONTEND_BASE_URL.replace(/\/+$/, '')
  : undefined,
  REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  REACT_APP_AWS_S3_BUCKET_NAME: process.env.REACT_APP_AWS_S3_BUCKET_NAME,
  REACT_APP_AWS_S3_BUCKET_ZONE: process.env.REACT_APP_AWS_S3_BUCKET_ZONE,
  REACT_APP_WS_PAY_URL: process.env.REACT_APP_WS_PAY_URL,
  REACT_APP_WS_PAY_SHOP_ID: process.env.REACT_APP_WS_PAY_SHOP_ID,
  MOBILE_LOGIN_URL: process.env.REACT_APP_FRONTEND_BASE_URL + '/mobile-login',
};
